<template>
    <!-- <div style="width: 100%;height:10vh">
        <TopMenu></TopMenu>
    </div> -->
    <div class="main">
        <div class="daohang">
            <el-menu active-text-color="#ffd04b" background-color="#545c64" class="el-menu-vertical-demo"
                text-color="#fff" @open="handleOpen" @close="handleClose" :default-openeds="['1', '2']"
                :default-active="$route.path" router>
                <el-sub-menu index="1">
                    <template #title>
                        <el-icon>
                            <location />
                        </el-icon>
                        <span>寻宠信息管理</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/pet/carousel">轮播图管理</el-menu-item>
                        <el-menu-item index="/pet/stats">统计表单管理</el-menu-item>
                        <el-menu-item index="/pet/users">小程序用户管理</el-menu-item>
                        <el-menu-item index="/pet/infos">帖子信息管理</el-menu-item>
                        <!-- <el-menu-item v-if="adminuser.level == 1" index="/admin/catalogInfo">目录管理</el-menu-item>
                        <el-menu-item index="/admin/sourceInfo">资源管理</el-menu-item>
                        <el-menu-item index="/admin/addSource">资源新增</el-menu-item> -->
                    </el-menu-item-group>
                </el-sub-menu>

                <el-sub-menu index="2">
                    <template #title>
                        <el-icon>
                            <location />
                        </el-icon>
                        <span>设置</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="/">工具箱</el-menu-item>
                        <el-menu-item index="logout" @click="out">退出登录</el-menu-item>
                    </el-menu-item-group>
                </el-sub-menu>
            </el-menu>
        </div>
        <div class="xuanxiangka">
            <div style="width: 100%">
                <router-view></router-view>
                <!-- <DynamicContent :component="currentComponent" /> -->
            </div>
        </div>
    </div>
</template>

<script>

import TopMenu from './TopMenu.vue'; // 根据实际路径调整

export default {
    components: {
        TopMenu
    },
    name: "PetIndexView",
    data() {
        return {
            role: sessionStorage.getItem("role"),
            zh: sessionStorage.getItem("usercode"),
            adminuser: JSON.parse(sessionStorage.getItem("adminuser")),
        };
    },
    mounted() {
    },
    methods: {
        out() {
            sessionStorage.removeItem("usercode");
            sessionStorage.removeItem("role");
            sessionStorage.setItem("s", false);
            this.$router.replace("/login");
        },
        goToolsHome() {
            this.$router.replace("/");
        },
        handleClick(row) {
            console.log(row);
        },
        handleOpen(key, keyPath) {
            console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
            console.log(key, keyPath);
        },

        handleMenuClick(component) {
            this.currentComponent = this.componentsMap[component];
        },
    },
};
</script>

<style scoped>
.main {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-between;

    width: 100%;
    height: 100vh;
}

.daohang {
    width: 20%;
}

.xuanxiangka {
    width: 80%;
}
</style>
